import React from "react";
import Header from "../../components/Header/LandingHeader";

import s from "./AboutMctag.module.scss";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../../../components/WindowDimensions/WindowDimensions";
import PageTitle from "../../components/PageTitle/PageTitle";
import MctacStructure from "../../components/MctacStructure/MctacStructure";

type Props = {};

const AboutMctag = (props: Props) => {
  const { width } = useWindowDimensions();
  return (
    <div>
      {width > 600 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <PageTitle className={s.h2} eyebrow="About us" title="What is MCTAC?" />
        <div className={s.text}>
          <div>
            <strong>Middle Corridor Transit Advisory Committee (MCTAC) </strong>
            is an international community, operating as a non-governmental
            organization, established by the{" "}
            <a
              href="https://anv.md"
              target="_blank"
              rel="noopener noreferrer"
              className={s.link}
            >
              National Customs Association of the Republic of Moldova (Asociația
              Națională Vamală - ANV)
            </a>
            .{" "}
            It serves as an advisory body composed of professionals and
            experienced experts in customs clearance and logistics across the
            countries of Europe and the Middle Corridor.
          </div>
          <div>
            The highest governing body of MCTAC is the Committee Council,
            approved by the National Customs Association of Moldova, which makes
            the Committee’s strategic decisions.{" "}
          </div>
          <div>
            The Middle Corridor Transit Advisory Committee is a community of
            experts from Europe and Middle Corridor countries located along the
            North–South and East–West routes, bringing together specialists with
            the knowledge and experience necessary to support the implementation
            of electronic trade systems and the facilitation of paperless trade
            procedures. MCTAC works closely with regional and global
            organizations, such as the European Union, the UN, the WCO, GIZ,
            ADB, and other international bodies.
          </div>
          <div>
            The Committee operates through regional representatives (partners)
            who organize and manage customs clearance processes for goods and
            vehicles, oversee logistics operations, and protect the rights of
            carriers and entrepreneurs in the regions where they represent
            MCTAC.
          </div>

          <div>
            The Committee has built business relationships based on the
            principles of public–private partnerships (PPP),
            business-to-business (B2B), and business-to- government (B2G). One
            of the Committee’s key objectives is to consolidate the capabilities
            of regional partners and specialists into a single platform,
            functioning as a TRANSIT MARKETPLACE, to provide comprehensive
            transit services aimed at supporting business development and
            increasing freight traffic along the Middle Corridor.
          </div>
        </div>
        <MctacStructure />
      </div>
      <LandingFooter />
    </div>
  );
};

export default AboutMctag;
